import {
    MdPersonSearch,
    MdAddCircleOutline,
    MdOutlineGroup,
    MdCalendarToday,
    MdList,
    MdOutlineMessage,
} from 'react-icons/md';

import { IoMdCheckmarkCircleOutline } from 'react-icons/io';

const referralsNavigation = [
    {
        id: 'new_referral',
        title: 'New Referral',
        icon: <MdAddCircleOutline size={20} />,
        navLink: '/new_referral',
        action: 'create',
        resource: 'lrs_referral',
    },
    {
        id: 'look_up',
        title: 'Look up',
        icon: <MdPersonSearch size={20} />,
        navLink: '/active_referrals',
        flagged: true,
        flaggedStatus: 'Declined',
        flaggedColor: '#C22725',
        action: 'read',
        resource: 'lrs_referral',
    },
    {
        id: 'new_referrals',
        title: 'New Referrals',
        icon: <MdOutlineGroup size={20} />,
        navLink: '/new_referrals',
        action: 'read',
        resource: 'lawyer_referrals',
    },
    {
        id: 'lead_intake',
        title: 'Leads',
        icon: <MdAddCircleOutline size={20} />,
        navLink: '/lead_intake',
        action: 'read',
        resource: 'lawyer_leads',
    },
    {
        id: 'us_lead_intake',
        title: 'Leads',
        icon: <MdAddCircleOutline size={20} />,
        navLink: '/lawyer_leads',
        action: 'read',
        resource: 'us_lawyer_leads',
    },
    {
        id: 'matters',
        title: 'Matters',
        icon: <MdList size={20} />,
        navLink: '/matters',
        action: 'read',
        resource: 'matters',
    },
    {
        id: 'us_matters',
        title: 'Matters',
        icon: <MdList size={20} />,
        navLink: '/lawyer_matters',
        action: 'read',
        resource: 'us_lawyer_matters',
    },
    {
        id: 'matter_appointments',
        title: 'Appointments',
        icon: <MdCalendarToday size={20} />,
        navLink: '/appointments',
        action: 'read',
        resource: 'matter_appointments',
    },
    {
        id: 'matter_tasks',
        title: 'Tasks',
        icon: <IoMdCheckmarkCircleOutline size={20} />,
        navLink: '/tasks',
        action: 'read',
        resource: 'matter_tasks',
    },
    {
        id: 'matter_messages',
        title: 'Messages',
        icon: <MdOutlineMessage size={20} />,
        navLink: '/messages',
        action: 'read',
        resource: 'matter_messages',
    },
];

export default referralsNavigation;
